
import {unstable_HistoryRouter as HistoryRouter, Routes, Route} from "react-router-dom";
import history from "./framework/history.js";
import {ConfigProvider} from "antd";

import Index from './pages/Index.js';
import AboutUs from "./pages/AboutUs.js";
import ContactUs from "./pages/ContactUs.js";
import Blogs from "./pages/Blogs.js";
import TermsAndConditions from "./pages/TermsAndConditions.js";
import PrivacyPolicy from "./pages/PrivacyPolicy.js";
import CategoryViewer from "./pages/CategoryViewer.js";
import ModelViewer from "./pages/ModelViewer.js";
import Home from "./pages/Home.js";
import AdminPanel from "./pages/AdminPanel.js";
import Login from "./pages/Login.js";
import BlogViewer from "./pages/BlogViewer.js";
import NotFound from "./pages/404";

function App() {
    return (
        <div>
            <ConfigProvider
                theme={{
                    token: {
                        colorPrimary: '#618c0f',
                        colorLink: '#1d1d1f',
                        colorLinkHover: '#618c0f',
                        colorLinkActive: '#618c0f',
                    },
                }}
            >
                <HistoryRouter history={history}>
                    <Routes>
                        {/*web端主页面，固定header，footer，下属包括首页在内的9个子页面*/}
                        <Route path="/" element={<Index/>}>
                            {/*首页，目前基本纯静态，要不要加blog窗口或者contact us窗口跟客户商量*/}
                            <Route index element={<Home/>}/>
                            {/*纯静态*/}
                            <Route path="/aboutUs" element={<AboutUs/>}/>
                            {/*带表单，提交后台触发邮件发送*/}
                            <Route path="/contactUs/:msg?" element={<ContactUs/>}/>
                            {/*博客总览页，渲染从后台拿到的list*/}
                            <Route path="/blogs" element={<Blogs/>}/>
                            {/*博客详情页，展示从后台拿到的富文本编辑器内容*/}
                            <Route path="/blogs/:blogId" element={<BlogViewer/>}/>
                            {/*纯静态*/}
                            <Route path="/termsAndConditions" element={<TermsAndConditions/>}/>
                            {/*纯静态*/}
                            <Route path="/privacyPolicy" element={<PrivacyPolicy/>}/>
                            {/*分类浏览器，多级渲染浏览来自后台的类别数据*/}
                            <Route path="/category/:categoryId?" element={<CategoryViewer/>}/>
                            {/*商品详情页，供用户浏览某一特定型号不同项目的价格*/}
                            <Route path="/category/:categoryId?/model/:modelId" element={<ModelViewer/>}/>
                            <Route path="/model/:modelId" element={<ModelViewer/>}/>
                        </Route>
                        {/*后台登录页面*/}
                        <Route path="/login" element={<Login/>}/>
                        {/*后台主页面，下属三个子页面*/}
                        <Route path="/admin" element={<AdminPanel/>}>
                            {/*网站后台的子页面不在router里，目前有3个子页面*/}
                            {/*category management,分类管理页面*/}
                            {/*model management,商品详情管理页面*/}
                            {/*blog management,博客发布管理页面*/}
                        </Route>
                        {/*通用404 not found页面*/}
                        <Route path="/*" element={<NotFound/>}/>
                    </Routes>
                </HistoryRouter>
            </ConfigProvider>
        </div>
    );
}

export default App;
